export const CALENDAR_MODES = ['gregorian', 'hebrew'] as const;

export type CalendarMode = (typeof CALENDAR_MODES)[number];

/** Preference for which calendar is primary on the transactions board and its date filter. */
export const CALENDAR_MODE_STORAGE_KEY = 'hz.calendarMode';

export const DEFAULT_CALENDAR_MODE: CalendarMode = 'gregorian';

export const isCalendarMode = (value: unknown): value is CalendarMode => CALENDAR_MODES.includes(value as CalendarMode);
